module.exports = __webpack_public_path__ + "static/lifedance-story-thumbnail-7f70f598aeece7cb563906c43382d20a.png";